import { VisibilityOffSharp, VisibilitySharp } from '@mui/icons-material';
import { MenuItem, Stack, TextField } from '@mui/material';
import { useEffect } from 'react';
import { useState } from 'react';

export const MidjourneyForm = ({ values, setValues }) => {
  const [passwordType, setPasswordType] = useState('password');
  return (
    <>
      <center>
        <TextField
          fullWidth
          autoFocus
          required
          variant="outlined"
          placeholder="Server ID"
          label="Server ID"
          style={{ marginTop: '10px' }}
          value={values.server_id}
          onChange={(e) => setValues({ ...values, server_id: e.target.value })}
        ></TextField>
      </center>

      <br></br>
      <center>
        <TextField
          fullWidth
          autoFocus
          required
          variant="outlined"
          placeholder="Channel ID"
          label="Channel ID"
          value={values.channel_id}
          onChange={(e) => setValues({ ...values, channel_id: e.target.value })}
        ></TextField>
      </center>

      <br></br>
      <center>
        <TextField
          fullWidth
          autoFocus
          type={passwordType}
          InputProps={{
            endAdornment: (
              <span
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                onClick={() => {
                  setPasswordType(passwordType === 'password' ? 'text' : 'password');
                }}
              >
                {passwordType === 'password' ? <VisibilitySharp /> : <VisibilityOffSharp />}
              </span>
            )
          }}
          required
          variant="outlined"
          placeholder="Discord Token"
          value={values.dc_token}
          label="Discord Token"
          onChange={(e) => setValues({ ...values, dc_token: e.target.value })}
        ></TextField>
      </center>
    </>
  );
};

export const GPTImageForm = ({ values, setValues }) => {
  const [passwordType, setPasswordType] = useState('password');
  return (
    <>
      <center>
        <TextField
          fullWidth
          autoFocus
          required
          variant="outlined"
          placeholder="API Key"
          label="OpenAI API Key"
          style={{ marginTop: '10px' }}
          InputProps={{
            endAdornment: (
              <span
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                onClick={() => {
                  setPasswordType(passwordType === 'password' ? 'text' : 'password');
                }}
              >
                {passwordType === 'password' ? <VisibilitySharp /> : <VisibilityOffSharp />}
              </span>
            )
          }}
          type={passwordType}
          value={values.dc_token}
          onChange={(e) => setValues({ ...values, dc_token: e.target.value })}
        ></TextField>
      </center>

      <Stack direction="row" spacing={2} style={{ marginTop: '20px' }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Image Quality"
          style={{ width: '100%' }}
          label="Image Quality"
          select
          value={values.quality ?? 'medium'}
          onChange={(e) => setValues({ ...values, quality: e.target.value })}
        >
          <MenuItem value="low">Low</MenuItem>
          <MenuItem value="medium">Medium</MenuItem>
          <MenuItem value="high">High</MenuItem>
        </TextField>
      </Stack>
    </>
  );
};

export const IdeogramImageForm = ({ values, setValues }) => {
  const [passwordType, setPasswordType] = useState('password');
  return (
    <>
      <center>
        <TextField
          fullWidth
          autoFocus
          required
          variant="outlined"
          placeholder="API Key"
          style={{ marginTop: '10px' }}
          label="Ideogram API Key"
          InputProps={{
            endAdornment: (
              <span
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                onClick={() => {
                  setPasswordType(passwordType === 'password' ? 'text' : 'password');
                }}
              >
                {passwordType === 'password' ? <VisibilitySharp /> : <VisibilityOffSharp />}
              </span>
            )
          }}
          type={passwordType}
          value={values.dc_token}
          onChange={(e) => setValues({ ...values, dc_token: e.target.value })}
        ></TextField>
      </center>

      <br></br>
      <TextField
        fullWidth
        variant="outlined"
        label="Image Model"
        select
        value={values.model ?? 'V_3'}
        onChange={(e) => setValues({ ...values, model: e.target.value })}
      >
        <MenuItem value="V_2">Ideogram V2</MenuItem>

        <MenuItem value="V_2_TURBO">Ideogram V2 Turbo</MenuItem>
        <MenuItem value="V_3">Ideogram 3.0</MenuItem>
      </TextField>
    </>
  );
};

export const FreepikForm = ({ values, setValues }) => {
  const [passwordType, setPasswordType] = useState('password');

  useEffect(() => {
    if (values.model === undefined) {
      setValues({ ...values, model: 'mystic' });
    }
    if (values.mysticModel === undefined) {
      setValues({ ...values, mysticModel: 'realism' });
    }
  }, [values]);
  const FREEPIK_MODELS = {
    mystic: 'mystic',
    classicFast: 'classicFast',
    googleImagen3: 'googleImagen3',
    fluxDev: 'fluxDev',
    reimagineFlux: 'reimagineFlux'
  };
  const MYSTIC_ENGINES = {
    gen: 'gen',
    fluid: 'fluid',
    realism: 'realism'
  };

  return (
    <>
      <center>
        <TextField
          fullWidth
          autoFocus
          required
          variant="outlined"
          placeholder="API Key"
          style={{ marginTop: '10px' }}
          label="Freepik API Key"
          InputProps={{
            endAdornment: (
              <span
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                onClick={() => {
                  setPasswordType(passwordType === 'password' ? 'text' : 'password');
                }}
              >
                {passwordType === 'password' ? <VisibilitySharp /> : <VisibilityOffSharp />}
              </span>
            )
          }}
          type={passwordType}
          value={values.dc_token}
          onChange={(e) => setValues({ ...values, dc_token: e.target.value })}
        ></TextField>
      </center>

      <br></br>

      <TextField
        fullWidth
        variant="outlined"
        label="Model"
        select
        value={values.model ?? FREEPIK_MODELS.mystic}
        onChange={(e) => setValues({ ...values, model: e.target.value })}
      >
        <MenuItem value={FREEPIK_MODELS.mystic}>Mystic</MenuItem>
        <MenuItem value={FREEPIK_MODELS.classicFast}>Classic Fast</MenuItem>
        <MenuItem value={FREEPIK_MODELS.googleImagen3}>Google Imagen 3</MenuItem>
        <MenuItem value={FREEPIK_MODELS.fluxDev}>Flux Dev</MenuItem>
      </TextField>

      <br></br>

      {values.model === FREEPIK_MODELS.mystic && (
        <TextField
          style={{ marginTop: '20px' }}
          fullWidth
          variant="outlined"
          label="Engine"
          select
          value={values.mysticModel ?? MYSTIC_ENGINES.realism}
          onChange={(e) => setValues({ ...values, mysticModel: e.target.value })}
        >
          <MenuItem value={MYSTIC_ENGINES.realism}>Realism</MenuItem>
          <MenuItem value={MYSTIC_ENGINES.gen}>Gen</MenuItem>
          <MenuItem value={MYSTIC_ENGINES.fluid}>Fluid</MenuItem>
        </TextField>
      )}
    </>
  );
};

export const FluxImageForm = ({ values, setValues }) => {
  const [passwordType, setPasswordType] = useState('password');

  const FLUX_MODELS = [
    { name: 'FLUX.1 Kontext [pro]', value: 'flux-kontext-pro' },
    { name: 'FLUX.1 Kontext [max]', value: 'flux-kontext-max' },
    { name: 'FLUX1.1 [pro] Ultra', value: 'flux-pro-1.1-ultra' },
    { name: 'FLUX1.1 [pro]', value: 'flux-pro-1.1' },
    { name: 'FLUX.1 [pro]', value: 'flux-pro' },
    { name: 'FLUX.1 [dev]', value: 'flux-dev' }
  ];

  return (
    <>
      <center>
        <TextField
          fullWidth
          autoFocus
          required
          variant="outlined"
          placeholder="API Key"
          style={{ marginTop: '10px' }}
          label="Flux API Key"
          InputProps={{
            endAdornment: (
              <span
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                onClick={() => {
                  setPasswordType(passwordType === 'password' ? 'text' : 'password');
                }}
              >
                {passwordType === 'password' ? <VisibilitySharp /> : <VisibilityOffSharp />}
              </span>
            )
          }}
          type={passwordType}
          value={values.dc_token}
          onChange={(e) => setValues({ ...values, dc_token: e.target.value })}
        ></TextField>
      </center>

      <TextField
        fullWidth
        variant="outlined"
        label="Model"
        select
        value={values.model ?? FLUX_MODELS[0].value}
        onChange={(e) => setValues({ ...values, model: e.target.value })}
        style={{ marginTop: '20px' }}
      >
        {FLUX_MODELS.map((model) => (
          <MenuItem key={model.value} value={model.value}>
            {model.name}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
};

export const GeminiImageForm = ({ values, setValues }) => {
  const [passwordType, setPasswordType] = useState('password');
  const GEMINI_MODELS = [
    { name: 'Nano Banana', value: 'gemini-2.5-flash-image' },
    { name: 'Nano Banana Pro', value: 'gemini-3-pro-image-preview' }
  ];

  return (
    <>
      <center>
        <TextField
          fullWidth
          autoFocus
          required
          variant="outlined"
          placeholder="API Key"
          label="Gemini API Key"
          style={{ marginTop: '10px' }}
          InputProps={{
            endAdornment: (
              <span
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                onClick={() => {
                  setPasswordType(passwordType === 'password' ? 'text' : 'password');
                }}
              >
                {passwordType === 'password' ? <VisibilitySharp /> : <VisibilityOffSharp />}
              </span>
            )
          }}
          type={passwordType}
          value={values.dc_token}
          onChange={(e) => setValues({ ...values, dc_token: e.target.value })}
        ></TextField>

        <br></br>
        <br></br>
        <TextField
          fullWidth
          variant="outlined"
          label="Model"
          select
          value={values.model ?? GEMINI_MODELS[0].value}
          onChange={(e) => setValues({ ...values, model: e.target.value })}
        >
          {GEMINI_MODELS.map((model) => (
            <MenuItem key={model.value} value={model.value}>
              {model.name}
            </MenuItem>
          ))}
        </TextField>
      </center>
    </>
  );
};
